import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, onPrintQR, title, message, type = 'warning' }) => {
  if (!isOpen) return null;

  const getIconConfig = () => {
    switch (type) {
      case 'success':
        return { name: 'CheckCircle2', color: 'var(--color-success)' };
      case 'error':
        return { name: 'XCircle', color: 'var(--color-error)' };
      case 'warning':
      default:
        return { name: 'AlertTriangle', color: 'var(--color-warning)' };
    }
  };

  const iconConfig = getIconConfig();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-card rounded-lg border border-border elevation-3 w-full max-w-md p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex flex-col items-center text-center mb-6">
          <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
            type === 'success' ? 'bg-success/10' :
            type === 'error'? 'bg-error/10' : 'bg-warning/10'
          }`}>
            <Icon name={iconConfig?.name} size={32} color={iconConfig?.color} />
          </div>
          
          <h3 className="text-xl font-semibold text-foreground mb-2">
            {title}
          </h3>
          
          <p className="text-sm text-muted-foreground">
            {message}
          </p>
        </div>

        <div className="flex items-center gap-3">
          {type === 'success' && onPrintQR && (
            <Button
              variant="outline"
              onClick={onPrintQR}
              iconName="QrCode"
              iconPosition="left"
              iconSize={16}
              fullWidth
            >
              Print QR Label
            </Button>
          )}
          
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            {type === 'success' ? 'Close' : 'Cancel'}
          </Button>
          
          <Button
            variant={type === 'error' ? 'destructive' : 'default'}
            onClick={onConfirm}
            fullWidth
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;